import { useEffect } from 'react';
import { useCurrentAccountId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildCreateAccountCompanyRequest } from './utils';

const useCreateAccountCompany = ({ onSuccess, onError }) => {
  const accountId = useCurrentAccountId();

  const {
    data: createAccountCompanyData,
    error: createAccountCompanyError,
    doFetch: doCreateAccountCompanyFetch,
  } = useDataApi();

  const createAccountCompanyRequest = (
    name,
    trade = '',
    addresses = [],
    websiteUrl = '',
    description = '',
    erpId = '',
    taxId = ''
  ) => {
    const companyData = {
      name,
      trade,
      addresses,
      websiteUrl,
      description,
      erpId,
      taxId,
    };
    doCreateAccountCompanyFetch(
      ...buildCreateAccountCompanyRequest(accountId, companyData)
    );
  };

  // Handle create account company error
  useEffect(() => {
    if (createAccountCompanyError === null) return;

    onError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createAccountCompanyError]);

  useEffect(() => {
    if (createAccountCompanyData === null) return;

    const companyId = createAccountCompanyData.id;
    onSuccess(companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createAccountCompanyData]);

  return {
    createAccountCompanyRequest,
  };
};

export default useCreateAccountCompany;
